export const MAX_DAILY_MINUTES = 1440;

/**
 * Effort in minuti (numero intero, come deciso per tutti gli inserimenti: niente ore o decimali).
 * @returns {{ minutes: number, valid: boolean, empty: boolean, error: string|null }}
 */
export function parseEffort(input) {
  const raw = String(input ?? '').trim();
  if (!raw) return { minutes: 0, valid: false, empty: true, error: null };

  const minutes = /^\d+$/.test(raw) ? parseInt(raw, 10) : null;
  if (minutes === null) return { minutes: 0, valid: false, empty: false, error: 'Enter whole minutes, e.g. 90' };
  if (minutes <= 0) return { minutes: 0, valid: false, empty: false, error: 'Effort must be greater than 0' };
  if (minutes > MAX_DAILY_MINUTES) return { minutes, valid: false, empty: false, error: 'Max 24h per worklog' };
  return { minutes, valid: true, empty: false, error: null };
}

/** 90 → "1h 30m", 45 → "45m", 120 → "2h" */
export function formatMinutes(minutes) {
  const total = Math.round(Number(minutes) || 0);
  if (total <= 0) return '0h';
  const h = Math.floor(total / 60);
  const mins = total % 60;
  if (h && mins) return `${h}h ${mins}m`;
  return h ? `${h}h` : `${mins}m`;
}
